import type { EnvironmentStand } from './environment-stands'

// Эндпоинты SnowPlow для каждого стенда проекта
export const SNOWPLOW_ENDPOINTS: Record<EnvironmentStand, string> = {
  dev: 'https://dev-rp.rshb.ru:443/api/dbofl/clickstreams',
  test: 'https://dev-rp.rshb.ru:8443/api/dbofl/clickstreams',
  preprod: 'https://dev-rp.rshb.ru:8443/api/dbofl/clickstreams',
  prod: 'https://rp.rusagrobank.com/api/dbofl/clickstreams',
}

// Стенды SnowPlow для каждого стенда проекта
export const SNOWPLOW_STANDS: Record<EnvironmentStand, string> = {
  dev: 'dev-stand',
  test: 'test-stand',
  preprod: 'preprod-stand',
  prod: 'prod-stand',
}

// Путь к основному скрипту SnowPlow
export const SNOWPLOW_SCRIPT_URL = '/shared/sp.js'

// Путь к трекер скрипту SnowPlow
export const SNOWPLOW_TRACKER_URL = '/shared/rptracker.js'
